module.exports = __webpack_public_path__ + "static/icon_contatti_whatsapp-34e5cc474cca65d55636739a7106cf6c.svg";